import { TRUST_BADGES } from "@/lib/site";

export default function TrustBand() {
  return (
    <section
      className="border-y border-slate-200 bg-slate-50 py-10"
      data-testid="trust-band"
    >
      <div className="fg-container grid grid-cols-2 gap-y-6 md:grid-cols-6">
        {TRUST_BADGES.map((b) => {
          const Icon = b.icon;
          return (
            <div
              key={b.label}
              className="flex items-center gap-3"
              data-testid={`trust-badge-${b.label.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and")}`}
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-sky-100 text-blue-700">
                <Icon className="h-5 w-5" />
              </div>
              <div className="text-sm font-bold text-slate-900">
                {b.label}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
